import { render, staticRenderFns } from "./violationDetailContent.vue?vue&type=template&id=135090a3&scoped=true"
import script from "./violationDetailContent.vue?vue&type=script&lang=js"
export * from "./violationDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135090a3",
  null
  
)

export default component.exports